import {
  Tab as MaterialTab,
  TabProps,
  Tabs as MaterialTabs,
  TabsProps,
} from "@material-ui/core";
import { omit } from "lodash";
import React, { FunctionComponent } from "react";
import styled from "styled-components";
import { colours } from "../../styles/colours";
import { WIDGET_BORDER_RADIUS } from "../widget";
import { tabsStylesHook } from "./style";

export const Tabs = (
  props: TabsProps & { tabIndex: number; setTabIndex: (t: number) => void }
) => {
  const tabsStyles = tabsStylesHook.useTabs();
  return (
    <MaterialTabs
      {...omit(props, "tabIndex", "setTabIndex")}
      variant="fullWidth"
      classes={tabsStyles}
      value={props.tabIndex}
      onChange={(e, index) => props.setTabIndex(index)}
    />
  );
};

export const Tab = (props: TabProps) => {
  const tabItemStyles = tabsStylesHook.useTabItem();
  return <MaterialTab classes={tabItemStyles} {...props} />;
};

export interface ICustomTabsProps {
  tabs: Array<{
    title: React.ReactNode;
    content: React.ReactNode;
  }>;
}

const TabTitles = styled.div`
  display: flex;
  justify-content: space-around;
  background: ${colours.lightestBlue};
  border-top-right-radius: ${WIDGET_BORDER_RADIUS};
  border-top-left-radius: ${WIDGET_BORDER_RADIUS};
`;

const TabTitle = styled.div<{ isActive: boolean }>`
  font-weight: 700;
  color: ${(props) => (props.isActive ? colours.black : colours.darkGrey)};
  border-bottom: ${(props) =>
    props.isActive ? "2px solid " + colours.darkGrey : ""};
  padding: 01em;
  flex-grow: 1;
  text-align: center;
  border-top-right-radius: ${WIDGET_BORDER_RADIUS};
  border-top-left-radius: ${WIDGET_BORDER_RADIUS};
  cursor: pointer;
`;

const Wrapper = styled.div`
  background: ${colours.white};
  border-radius: ${WIDGET_BORDER_RADIUS};
`;

export const CustomTabs: FunctionComponent<ICustomTabsProps> = ({ tabs }) => {
  const [tabIndex, setTabIndex] = React.useState(0);
  return (
    <Wrapper>
      <TabTitles>
        {tabs.map(({ title }, index) => (
          <TabTitle
            key={index}
            isActive={index === tabIndex}
            onClick={() => setTabIndex(index)}
          >
            {title}
          </TabTitle>
        ))}
      </TabTitles>
      <div>{tabs[tabIndex]?.content || null}</div>
    </Wrapper>
  );
};
